import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-shortcuts',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-shortcuts.component.html',
  styleUrls: ['./admin-shortcuts.component.css']
})
export class AdminShortcutsComponent {

  constructor(private router: Router) { }

  /**
   * Navigates to the specified admin panel route.
   * @param path The child path within the admin panel (e.g., 'set-type').
   */
  navigateTo(path: string): void {
    // All shortcuts lead to a route under '/admin-panel/'
    this.router.navigate(['/admin-panel', path]);
  }
}